import { createSlice } from "@reduxjs/toolkit";

const initialAuthState = {
  isAuthenticated: false,
  token: null,
  roles: {},
  first_name: null,
  last_name: null,
  access: null,
  email: null,
  id: null,
  loader: true,
  loader_text: "",
  whitelabel: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    resetState(state) {
      state.isAuthenticated = false;
      state.token = null;
      state.roles = {};
      state.first_name = null;
      state.last_name = null;
      state.access = null;
      state.email = null;
      state.id = null;
      state.loader = true;
      state.loader_text = "";
      state.whitelabel = null;
    },
    login(state, action) {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.first_name = action.payload.first_name;
      state.last_name = action.payload.last_name;
      state.access = action.payload.access;
      state.email = action.payload.email;
      state.id = action.payload.id;
      state.loader = false;

      if (!state.roles.role_id) {
        state.roles = action.payload.roles;
      }
      state.whitelabel = action.payload.whitelabel || null;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.token = null;
    },
    setLoaderStatus(state, action) {
      state.loader = action.payload.status;
      state.loader_text = action?.payload.loader_text;
    },
    setWhitelabel(state, action) {
      state.whitelabel = action.payload;
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
